import {
  FETCH_IQ_LOADING, FETCH_IQ_DONE, FETCH_IQ_ERROR,
  FETCH_IQ_BY_ID_LOADING, FETCH_IQ_BY_ID_DONE, FETCH_IQ_BY_ID_ERROR,
  PUT_EDIT_IQ_LOADING, PUT_EDIT_IQ_DONE, PUT_EDIT_IQ_ERROR,
  DOWNLOAD_QUOTATION_INVOICE_LOADING, DOWNLOAD_QUOTATION_INVOICE_DONE, DOWNLOAD_QUOTATION_INVOICE_ERROR
} from './actions'

export default {
  [FETCH_IQ_LOADING] (state) {
    state.isLoading = true
    state.itemExtend = false
  },

  [FETCH_IQ_DONE] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [FETCH_IQ_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FETCH_IQ_BY_ID_LOADING] (state) {
    state.isLoadingIqDetail = true
    state.errorIqDetail = false
  },

  [FETCH_IQ_BY_ID_DONE] (state, items) {
    state.iqDetail = items
    state.isLoadingIqDetail = false
    state.errorIqDetail = false
  },

  [FETCH_IQ_BY_ID_ERROR] (state, error) {
    state.errorIqDetail = error
    state.isLoadingIqDetail = false
  },

  [PUT_EDIT_IQ_LOADING] (state) {
    state.isLoadingEditIq = true
  },
  [PUT_EDIT_IQ_DONE] (state, items) {
    state.editIq = items
    state.isLoadingEditIq = false
  },
  [PUT_EDIT_IQ_ERROR] (state, error) {
    state.errorEditIq = error
    state.isLoadingEditIq = false
  },

  [DOWNLOAD_QUOTATION_INVOICE_LOADING] (state) {
    state.isDownloadingInvoice = true
    state.errorDownloadingInvoice = false
  },
  [DOWNLOAD_QUOTATION_INVOICE_DONE] (state) {
    state.isDownloadingInvoice = false
    state.errorDownloadingInvoice = false
  },
  [DOWNLOAD_QUOTATION_INVOICE_ERROR] (state) {
    state.errorDownloadingInvoice = true
    state.isDownloadingInvoice = false
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/instantQuote/mutations.js